import React from 'react';

export default function LudiAiFeedbackCard({ feedback, serieLabel }) {
  if (!feedback) return null;
  return (
    <div className="bg-[var(--ludi-ai-bg)] border border-[var(--ludi-ai-bdr)] rounded-ludi-md p-ludi-4">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-[6px] h-[6px] rounded-full flex-shrink-0 bg-[var(--ludi-ai-acc)] shadow-[0_0_6px_var(--ludi-ai-acc)] animate-pulse" />
        <span className="text-ludi-micro font-bold uppercase tracking-widest text-[var(--ludi-ai-acc)]">IA</span>
        {serieLabel && (
          <span className="text-ludi-sm text-ludi-t60 ml-auto font-semibold">{serieLabel}</span>
        )}
      </div>
      <p className="text-ludi-base text-ludi-t100 leading-relaxed">{feedback}</p>
    </div>
  );
}
